import React, {useEffect, useState} from 'react';
import {
  FileInfo,
  FileInput, FileInputWrapper, FileUploaded, RemoveDoc, Uploader
} from '../fileUploader/FileUploader.styles';
import redUploadIcon from '../../../images/red-upload.svg';
import fileTypeIcon from '../../../images/file-type-icon.svg';
import fileTypeDocIcon from '../../../images/fileTypeDoc.svg';
import deleteIcon from '../../../images/delete.svg';

import { GradientTextColor, InputLabel, LargeBoldText, LargeText, MediumItalicText, PrimaryButton, RegularText, SecondaryButton, SmallBoldText, SmallText, XSmallBlackText } from '../input/TextField.styles';

export const FileUploader = (props) => {

  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [uploadedFileInfo, setUploadedFileInfo] = useState({});

  useEffect(() => {
    props.setFileData(uploadedFileInfo);
  }, [uploadedFileInfo]);

  const fileSelectHandler = (event) => {
    resetUpload();
    try{
      let fileMetaData = {
        "fileBuffer": null,
        "fileName": null,
        "fileExt": null
      };
      let files = event.target.files[0];
      let reader = new FileReader();
      reader.onload = function (event) {
        let binary = '';
        let bytes = new Uint8Array(event.target.result);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        fileMetaData.fileBuffer = btoa(binary);
      };
      reader.readAsArrayBuffer(files);
      fileMetaData.fileName = files.name;
      fileMetaData.fileExt = files.name.split(".")[1];
      setUploadedFileInfo({ ...[], name: '', size: 0, sizeUnit: '', type: '', percentage: 0, uploadHide: true, validFileType: null})
      let fileUpType = fileMetaData.fileExt;
      setFileType(fileUpType);
      setUploadedFileInfo({ ...[],size: files.size, type: fileUpType})
      if(Math.round(files.size / 1024) / 1000 > 1)
      {
        setUploadedFileInfo({ ...[], sizeUnit: 'MB' })
      }else{
        setUploadedFileInfo({ ...[], sizeUnit: 'KB' })
      }
      if (((fileUpType === "doc") || (fileUpType === "docx") || (fileUpType === "pdf")) && (Math.round(files.size / 1024) / 1000) < 5) {
        setFileName(fileMetaData.fileName)
        setFileUploaded(true);
        setUploadedFileInfo({ ...[], name: files.name, validFileType: true ,isUploaded:true ,selectedFile: event.target.files[0], file: fileMetaData})
        props.setFileData(uploadedFileInfo);
      }
      else {
        setUploadedFileInfo({ ...[], validFileType: false, uploadHide: false, selectedFile: "", isUploaded:false , size:files.size, file: {}})
      }
    }catch(ex){
      setUploadedFileInfo({name: '', size: 0, sizeUnit: '', type: '', percentage: 0, uploadHide: false,validFileType:false});
    }
    props.setFileData(uploadedFileInfo);
  }

  const resetUpload = () => {
    setFileUploaded(false);
    setUploadedFileInfo({ ...[], name: '', size: 0, sizeUnit: '', type: '', percentage: 0, uploadHide: false, isUploaded:false , validFileType: null })
  }


  return (
    <div style={{
      'gap': '8px',
      'display': 'flex',
      'flexDirection': 'column',
      'alignSelf': 'stretch'
    }}>
    <InputLabel>{props.uploadLabel}</InputLabel>
    { !fileUploaded ?
    <FileInputWrapper>
      <Uploader>
      <FileInput type="file" id="upload_input" name="files[]" data-multiple-caption="{count} files selected" multiple
                        onDragEnter="document.getElementById('file_upload').textContent = ''; event.stopPropagation(); event.preventDefault();"
                        onDragOver="event.stopPropagation(); event.preventDefault();"
                        onDrop="event.stopPropagation(); event.preventDefault();
                                   dodrop(event);" onChange={fileSelectHandler} />
 
        <img src={redUploadIcon} alt='upload'/>

        <div>

          <GradientTextColor>Click to Upload&nbsp;</GradientTextColor>
          <RegularText>or drag and drop</RegularText>
          <XSmallBlackText>
            <span>Accepted file type: PDF and docx.</span>
          </XSmallBlackText>
          <XSmallBlackText>
            <span>Max file size: 5MB</span>
          </XSmallBlackText>
        </div>
        </Uploader>
    </FileInputWrapper>
    :

        <FileUploaded>
          <img src={(fileType === 'doc'|| fileType ==='docx') ? fileTypeDocIcon : fileTypeIcon}/>
          <FileInfo>
            <MediumItalicText>Document description</MediumItalicText>
            <LargeBoldText>{fileName}</LargeBoldText>
            <RemoveDoc onClick={resetUpload}>
              <img style={{cursor: "pointer"}} width={'18px'} height={'18px'} src={deleteIcon} alt='delete'/>
              <SmallBoldText>Remove</SmallBoldText>
            </RemoveDoc>
          </FileInfo>
        </FileUploaded>
      }
      {
        (uploadedFileInfo.validFileType === false && (Math.round(uploadedFileInfo?.size / 1024) / 1000) < 5) &&
        <SmallText isError>Please check file type and re-upload, file type should be .pdf, docx</SmallText>
      }
      <span>{uploadedFileInfo.files?.size}</span>
      {
        (Math.round(uploadedFileInfo?.size / 1024) / 1000) > 5 &&
        <SmallText isError>Please reduce the size of the file and try again. Max file size: 5MB</SmallText>
      }

    </div>
  ) 
}